import React from 'react'
import { required, SelectInput, SelectInputProps } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'

const defaultProps = {
  label: `${COMMON_FIELDS}.type.label`,
  source: 'type',
  choices: [
    { id: 'c', name: `${COMMON_FIELDS}.type.choices.common` },
    { id: 'p', name: `${COMMON_FIELDS}.type.choices.branch` },
  ],
}

export const TypeSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  ...props
}) => {
  return (
    <SelectInput
      margin='none'
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      {...props}
    />
  )
}

TypeSelectInput.defaultProps = defaultProps
